<template>
  <BannerBlock titleClass="">
    <template v-slot:title>{{$t("banner.welcomeBackDesc")}}</template>
    <template v-slot:message>
      {{$t("banner.welcomeBack")}}
    </template>
    <template v-slot:actions>
      <button class="btn btn-g-primary" @click="$chatbox.show">{{$t("generals.liveC")}}</button>
    </template>
    <template v-slot:default>
      <!-- <div class="bg ml-auto col-sm-4 d-none d-sm-unset"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/welcome-back.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../BannerBlock";
export default {
  name: "WelcomeBack",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {
  }
};
</script>
<style lang="scss" scoped>
</style>
